import { addClass, removeClass } from '../../utility/domUtils';

export function showSpinner() {
  addClass('#button-factory-spinner', ['show']);
}

export function hideSpinner() {
  removeClass('#button-factory-spinner', ['show']);
}
